var exports = {
  "t": "DataDeletionTab.module__deleteSection___cHhVSW",
  "i": "DataDeletionTab.module__warningText___cHhVSW",
};

module.exports = exports;
